<template>
  <Card
    :title="subscriberName"
    class="SubscriberDetailsCard"
  >
    <template #header-action>
      <ActionButton
        v-if="isTabletOrDesktop"
        class="SubscriberDetailsCard-actionsTrigger"
        variant="tertiary"
        leftIcon="pencil"
        @click="$emit('edit')"
      >
        {{ t('ui.subscriber.details.editDetails') }}
      </ActionButton>

      <IconButton
        v-else
        class="SubscriberDetailsCard-actionsTrigger"
        icon="pencil"
        size="md"
        :ariaLabel="t('ui.subscriber.details.editDetails')"
        @click="$emit('edit')"
      />
    </template>

    <div class="SubscriberDetailsCard-content">
      <SubscriberContent :subscriber="subscriber" />
    </div>
  </Card>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from '@cvo/i18n/composables/useI18n';
import { useResponsive } from '@cvo/ui/composables';
import type { SubscriberResponse } from '@cvo/domain';
import Card from '../../atoms/Card/Card.vue';
import ActionButton from '../../atoms/ActionButton/ActionButton.vue';
import IconButton from '../../atoms/IconButton/IconButton.vue';
import SubscriberContent from './SubscriberContent.vue';

interface SubscriberDetailsCardProps {
  subscriber: SubscriberResponse;
}

const props = defineProps<SubscriberDetailsCardProps>();

const emit = defineEmits<{
  (e: 'edit'): void;
}>();

const { t } = useI18n();
const { isTabletOrDesktop } = useResponsive();

const subscriberName = computed(() => `${props.subscriber.person.firstName} ${props.subscriber.person.middleName ? `${props.subscriber.person.middleName  } ` : ''}${props.subscriber.person.lastName}`);
</script>

<style lang="scss">
@use '@cvo/ui/styles/utils/layout';
@use '@cvo/ui/styles/utils/responsive';
@use '@cvo/ui/styles/utils/text';
@use '@cvo/ui/styles/design-system' as vars;

@layer cvo-ui {
  .SubscriberDetailsCard {
    display: flex;
    flex-direction: column;
    gap: vars.$dimensions-d-6;
    padding: vars.$dimensions-d-5;
    position: relative;

    &-actionsTrigger {
      padding-inline: 0;
    }
  }
}
</style>
